import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';

export type IToastMessageType = 'error' | 'info' | 'success' | 'warn';

export interface IToastMessage {
    id?: string;
    text: string;
    type?: IToastMessageType;
}

export interface IToast {
    renderer: () => JSX.Element | null;
    show: (message: IToastMessage & Partial<{ id: string }>, duration?: number) => void;
    hide: (message: Partial<IToastMessage>) => void;
    update: (message: IToastMessage & { id: string }) => void;
    message: (id: string) => IToastMessage | undefined;
    isShowing: (message: Partial<IToastMessage>) => boolean;
    allMessages: () => (IToastMessage & { id: string; type: IToastMessageType })[];
}

export const TYPES = {
    IToast: Symbol.for('IToast'),
};

export function injectToast(container: IContainer = injectOrBuildContainer()): Readonly<IToast> {
    return container.get<IToast>(TYPES.IToast);
}

export function bindToast(val: IToast, container: IContainer = injectOrBuildContainer()): void {
    container.bind<IToast>(TYPES.IToast, val);
}

export function unbindToast(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IToast);
}
